import type { IconProps } from './IconProps';

export const DarkModeIcon = (props: IconProps) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 16}
    height={props.height ?? 16}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.22379 1.46969C6.44449 1.69039 6.50544 2.02469 6.37683 2.30907C6.0635 3.00192 5.88869 3.7715 5.88869 4.58394C5.88869 7.63663 8.36339 10.1113 11.4161 10.1113C12.2285 10.1113 12.9981 9.93653 13.691 9.62319C13.9753 9.49458 14.3096 9.55553 14.5303 9.77623C14.751 9.99692 14.812 10.3312 14.6834 10.6156C13.5815 13.0522 11.1285 14.75 8.27739 14.75C4.39627 14.75 1.25 11.6038 1.25 7.72264C1.25 4.87153 2.94784 2.41857 5.38442 1.31665C5.6688 1.18805 6.0031 1.249 6.22379 1.46969ZM4.43821 3.74592C3.39687 4.75152 2.75 6.16192 2.75 7.72264C2.75 10.7753 5.2247 13.25 8.27739 13.25C9.8381 13.25 11.2485 12.6031 12.2541 11.5618C11.9792 11.5945 11.6995 11.6113 11.4161 11.6113C7.53496 11.6113 4.38869 8.46506 4.38869 4.58394C4.38869 4.3005 4.40551 4.02084 4.43821 3.74592Z"
      fill="currentColor"
    />
  </svg>
);
